import { Link } from "react-router-dom";
import { languageObject } from "assets/data/languages";
import { IconInput, SVG, Switch } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

import { languagesArray } from "assets/data/languages";
import { useEffect, useState } from "react";

export type LangsProps = CustomComponentProps & {
    isPage?: boolean;
    selectedLanguages: languageObject[];
    toggleLang: (lang: languageObject) => void;
    handleHide?: Function;
};

const Langs = ({
    isPage = false,
    handleHide,
    selectedLanguages,
    toggleLang,
    className,
    style
}: LangsProps) => {
    const [filter, setFilter] = useState("");
    const [filteredLangArr, setFilteredLangArr] =
        useState<languageObject[]>(languagesArray);

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
        const filteredArr = languagesArray.filter(
            (i) =>
                i.name.toLowerCase().indexOf(e.target.value) > -1 ||
                i.nativeName.toLowerCase().indexOf(e.target.value) > -1
        );
        setFilteredLangArr(filteredArr);
    };

    const [disableSwitchsClass, setDisableSwtchsClass] = useState(false);

    useEffect(() => {
        setDisableSwtchsClass(selectedLanguages.length >= 4);
    }, [selectedLanguages]);

    return (
        <div
            className={`settings-page langs-container ${className}`}
            style={style}
        >
            <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                {isPage ? (
                    <Link to="/settings">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                ) : (
                    <div onClick={() => handleHide && handleHide()}>
                        <SVG svg="chevron-left" size={24} />
                    </div>
                )}
                <h1 className="fw-700 fs-12em">Select Languages</h1>
                <div></div>
            </div>
            <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                <p className="momeento-p">
                    You can select up to four languages to explore your posts
                    and incidents to all users who speak same language you
                    selected.
                </p>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-j-start mb-10">
                        <h2 className="fs-1.5 fw-500 white-text">
                            Selected Languages
                        </h2>
                    </div>
                    <div className="d-flex flex-j-start flex-a-start flex-wrap gap-10 mb-30">
                        {selectedLanguages.map((lang) => (
                            <div
                                key={lang.code}
                                className="button is-primary is-rounded raised d-flex flex-j-between flex-a-center gap-5"
                                onClick={() => toggleLang(lang)}
                            >
                                <span className="lang-name">
                                    {lang.nativeName}
                                </span>
                                <span className="remove-lang close-svg momeento-svg"></span>
                            </div>
                        ))}
                    </div>

                    <div className="control">
                        <IconInput
                            value={filter}
                            handleChange={handleChangeFilter}
                            rounded={true}
                        />

                        <ul id="lang-ul">
                            {filteredLangArr.map((lang) => (
                                <li
                                    key={lang.code}
                                    className="lang-li d-flex flex-j-between pl-10 gap-10"
                                >
                                    <span className="lang-span fw-500 white-text">
                                        {lang.name} ({lang.nativeName})
                                    </span>
                                    {selectedLanguages.some(
                                        (l) => l.code == lang.code
                                    ) ? (
                                        <Switch
                                            handleClick={() => toggleLang(lang)}
                                            checked={true}
                                        />
                                    ) : (
                                        <Switch
                                            handleClick={() => toggleLang(lang)}
                                            disabled={disableSwitchsClass}
                                            checked={false}
                                        />
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Langs;
